import { createSlice } from '@reduxjs/toolkit';

const localStorageData = JSON.parse(localStorage.getItem('userPreferences') || '{}');

const uiPreference = localStorageData.uiPreference || {
  darkMode: false,
  defaultPaginationValue: 10,
};

// Ensure preferences object always has darkMode property
if (typeof uiPreference.darkMode === 'undefined') {
  uiPreference.darkMode = false;
}
const userStamps = localStorageData.uiPreference?.userStamps || [];

const initialMode = localStorage.getItem('mode')
  ? localStorage.getItem('mode')
  : uiPreference.darkMode
    ? 'dark'
    : 'light'; // Default to light mode

// Ensure mode and preferences.darkMode are synchronized
const isDarkMode = initialMode === 'dark';
uiPreference.darkMode = isDarkMode;

const initialState = {
  token: null,
  user: null,
  mode: initialMode,
  preferences: uiPreference,
  userStamps: userStamps,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    changeMode: (state) => {
      if (state.mode === 'light') {
        state.mode = 'dark';
        state.preferences.darkMode = true;
        localStorage.setItem('mode', 'dark');
      } else {
        state.mode = 'light';
        state.preferences.darkMode = false;
        localStorage.setItem('mode', 'light');
      }
      
      // Update localStorage with new preferences
      const localData = JSON.parse(localStorage.getItem('userPreferences') || '{}');
      localData.uiPreference = state.preferences;
      localStorage.setItem('userPreferences', JSON.stringify(localData));
    },
    setPreferences: (state, action) => {
      state.preferences = action.payload;
      const localData = JSON.parse(localStorage.getItem('userPreferences') || '{}');
      localData.uiPreference = action.payload;
      localStorage.setItem('userPreferences', JSON.stringify(localData));
    },
    setUserStamps: (state, action) => { // New reducer for userStamps
      state.userStamps = action.payload;
      const localData = JSON.parse(localStorage.getItem('userPreferences') || '{}');
      localData.userStamps = action.payload;
      localStorage.setItem('userPreferences', JSON.stringify(localData));
    },
  },
});

export const { setCredentials, setToken, changeMode, setPreferences, setUserStamps } = userSlice.actions;

export default userSlice.reducer;
